jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.gallery-accordions').length ) {
        let $ = jQuery;

        $('.gallery-accordion .title').on('click', function () {
            if($(this).parents(".gallery-accordion").hasClass('open')) {
                $(this).parents(".gallery-accordion").removeClass('open');
            } else {
                $('.gallery-accordion.open').removeClass('open');
                $(this).parents(".gallery-accordion").toggleClass('open');
                $sliderGal = $(this).parents(".gallery-accordion").find('.gallery-images')
                $sliderGal.slick({
                    infinite: true,
                    dots: false,
                    autoplay: true,
                    arrows: true,
                    autoplaySpeed: 5000,
                    rows: 0
                });
                $sliderGal.on('afterChange', function (event, slick, currentSlide, nextSlide) {
                    var $slides = slick.$slides;
                    var id = $slides.eq(currentSlide).get(0).id;
                    $url = $("#" + id).data('image_url');
                    console.log($url);
                    $(this).parents('.gallery-accordion').css("background-image", 'url(' + $url + ')');
                });
            }
        });

    }
});